import { BackendConfig, SongsheetsConfig } from "../Config";
import { SongUb } from "../gql/graphql";

export function imageUrlsFor(song: SongUb): string[] {
  return song.imageHashes.map((derivedImage) =>
    imageUrlForHash(song.bucket, song.id, derivedImage.hash),
  );
}

export function imageUrlForHash(
  bucket: string,
  songId: string,
  imageHash: string,
): string {
  return `${SongsheetsConfig.url}/${bucket}/songs/${songId}/images/${imageHash}`;
}

export function sourceUrlsFor(song: SongUb): { hash: string; url: string }[] {
  return song.sourceHashes.map((h) => ({
    hash: h,
    url: sourceUrlForHash(song, h),
  }));
}

export function sourceUrlForHash(song: SongUb, hash: string): string {
  return `${BackendConfig.baseUrl}/${song.bucket}/songs/${song.id}/sources/${hash}`;
}

export function derivedImageUpdateUrl(
  bucket: string,
  songId: string,
  key: string,
): string {
  return `${BackendConfig.baseUrl}/${bucket}/songs/${songId}/derivedImages/${key}`;
}
